import {takeFirstDefinedForKeys} from 'powtoon-commons/utils'

const webvars = (window as any).webvars || {}
const assignedWebVars = takeFirstDefinedForKeys({
  pusherKey:                          [ process.env.PUSHER_KEY, webvars.pusher_key ],
  apiHost:                            [ process.env.API_HOST, webvars.api_host, '' ],
  userId:                             [ webvars.user_id, null ],
  logzioId:                           [webvars.logzio_id, null],
  logzioMetricsId:                    [webvars.logzio_metrics_id, 'LOGZIO_METRICS_ID_IS_MISSED'],
  logzioUrl:                          [webvars.logzio_url, 'https://listener.logz.io:8091'],
  min_log_level:                      [webvars.min_log_level, null],
  appLevel:                           [webvars.APP_LEVEL, null],
  clientIP:                           [webvars.client_ip, null],
  captureExtensionStoreLink:          [webvars.capture_extension_store_link,
                                       webvars.chrome_extension_store_link,
                                       'https://chrome.google.com/webstore/detail/powtoon-capture-screen-an/hgphbmgpkindhnldhjafhfflhjodpfmn?hl=en'],
  captureExtensionId:                 [webvars.capture_extension_id,
                                       webvars.extension_id,
                                       'hgphbmgpkindhnldhjafhfflhjodpfmn']
})

export default {
  getWebVars() {
    return assignedWebVars
  },

  getWebVar(propName: string) {
    return assignedWebVars[propName]
  }
}
